// ie11/10 bug fix
if (!window.navigator.msPointerEnabled) {
  try {
    document.domain = 'murdoch.edu.au';
  } catch (e) {
    console.warn(e);
  }
}
// set jquery to global
global.$ = global.jQuery = $;
window.jQuery = $;
// global.jquery2 = jquery2;